<div class="modal-body" *ngIf="reference">
    <h3>Ajustement d'inventaire</h3>

    <p class="lead">{{ reference.title }}</p>
    <p>{{ reference.isbn }}</p>

    <div class="alert alert-danger" *ngIf="error">
      <strong>Oh Noez!</strong>Une erreur est survenue!
      <button type="button" class="close" (click)="error=false">
        <span>&times;</span>
      </button>
    </div>
  
    <div class="form-group">
      <label>Quantité (+/-)</label>
      <input type="text" class="form-control" [class.is-invalid]="invalidQuantity" [(ngModel)]="newInventoryAdjustment.quantity">
      <div class="invalid-feedback" *ngIf="invalidQuantity">
        Quantité invalide
      </div>
    </div>
  
    <div class="form-group">
      <label>Commentaire</label>
      <input type="text" class="form-control" [class.is-invalid]="invalidComment" [(ngModel)]="newInventoryAdjustment.comment">
      <div class="invalid-feedback" *ngIf="invalidComment">
        Commentaire requis
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Annuler</button>
    <button type="button" class="btn btn-primary" [attr.disabled]="loading ? 'disabled' : null" (click)="createInventoryAdjustment()">
      <ng-container *ngIf="loading">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Chargement...
      </ng-container>
      <ng-container *ngIf="!loading">
        Créer l'ajustement
      </ng-container>
    </button>
  </div> 